import { createSelector } from 'reselect'

export const selectRequestsById = state => state.requests.byId || {}

export const selectRequestIds = createSelector(selectRequestsById, byId =>
  Object.keys(byId)
)
